import { dataPath } from 'dls-icons-data'
import { createIcon } from '../common'

const IconPath = /*#__PURE__*/createIcon(dataPath)
export default IconPath
